import React, { Suspense, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import { history } from "../../_redux/_store/history";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Grid,
  Tooltip,
  Button,
  TextField,
} from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { makeStyles } from "@material-ui/styles";
import AnomalyConfiguration from "./AnomalyConfiguration.jsx";
import {
  fetchFunction,
  fetchHMI,
  fetchNode,
  fetchScopedFindingRule,
  updateScopedFindingRule,
  setComponentLoading
} from "../../_redux/_actions/scopedFindingRuleActions";
import HelpBlockImg from "../../_assets/_images/helpBlock.png";
import ErrorHandler from "../updateHandlers/ErrorHandler";
import SkeletonPaper from "../skeleton/SkeletonPaper.jsx";
import Recommendation from "../recommendationList/recommendationList.jsx";
import { deleteScopedFinding } from "../../_redux/_actions/scopeListAction";
import { DeleteConfirmDialog } from "../updateHandlers/DeleteDialog";
import useDebounce from "../../utilities/useDebounce";
import {
  clearAnomalyState,
  fetchAnomalyType,
  setTypeFilters,
} from "../../_redux/_actions/anomalyRuleActions";
import { fetchAllAnomalyRule } from "../../_redux/_actions/detailsPersistActions";
import { fetchSelectFindingRule } from '../../_redux/_actions/selectFindingRuleAction';
import { BreadcrumbDispatch } from "../../App";

const useStyles = makeStyles(() => ({
  detailsPaper: {
    margin: "40px 0px",
    backgroundColor: "#F6F6F6",
    padding: "30px",
    width: "100%",
  },
  containerPaper: {
    height: "100%",
    padding: "30px",
    opacity: "1",
  },
  separator: {
    margin: "8px 15px",
  },
  label: {
    width: "88px",
  },
  icon: {
    color: "#ACACAC",
    margin: "5px",
  },
  editButton: {
    color: "#52A1C2",
  },
  deleteButton: {
    background: "white",
    color: "black",
  },
  textEditButton: {
    color: "blue",
    "&:hover": {
      backgroundColor: "inherit",
    },
  },
}));

export const ScopedFindingRuleConfigurationComponent = React.memo(() => {
  const classes = useStyles();
  const findingRuleResponse = useSelector(
    (state) => state.selectFindingRule
  );
  const [scopedFinding, setScopedFinding] = useState("");
  const [textEdit, setTextEdit] = useState(false);
  const [prioEdited, setPrioEdited] = useState(false);
  const [priority, setPriority] = useState('');
  const [note, setNote] = useState();
  const [parameters, setParameters] = useState({
    hmi: "",
    node: "",
    function: "",
  });
  const dispatch = useDispatch();
  const queryValues = queryString.parse(history.location.search);
  const {machine_type, hmi_type} = queryValues
  const findingRuleId = queryValues.findingRuleId;

  const scope = queryValues.scope;
  const machineType = scope
    ? scope.startsWith("global")
      ? scope.split(":")[1]
      : scope.split(":")[0]
    : null;
  const scopedFindingRuleResponse = useSelector(
    (state) => state.scopedFindingRule
  );
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const isdeleteSuccess = useSelector((state) => state.scopeList.deleteSuccess);
  const [error, setError] = useState("");
  const debounce = useDebounce();

  useEffect(() => {
    const body = { finding_rule_id: findingRuleId, scope: scope };
    if (!findingRuleId || !scope) {
      setError("Rule Id or Scope missing!");
    }
    async function fetchAll() {
      await dispatch(fetchSelectFindingRule(findingRuleId, machine_type,hmi_type));
      await dispatch(fetchScopedFindingRule(body,machine_type,hmi_type));
      await dispatch(fetchHMI({ machine_type: machine_type }));
      setTimeout(async() => {
         dispatch(fetchAllAnomalyRule(machine_type,hmi_type));
         dispatch(fetchAnomalyType(machine_type,hmi_type));
         dispatch(setComponentLoading(false))
      }, 1000);
    }
    fetchAll()
    return () => {
      dispatch(clearAnomalyState());
    };
  }, []);

  useEffect(() => {
    if (
      scopedFindingRuleResponse.scopedFindingRule &&
      scopedFindingRuleResponse.scopedFindingRule.length > 0
    ) {
      setScopedFinding(scopedFindingRuleResponse.scopedFindingRule[0]);
      setNote(scopedFindingRuleResponse.scopedFindingRule[0].note_text);
      setPriority(scopedFindingRuleResponse.scopedFindingRule[0].priority);
      let params = {
        hmi:
          scopedFindingRuleResponse.scopedFindingRule[0].plc_function_hmi_type,
        node: scopedFindingRuleResponse.scopedFindingRule[0].location_node,
        function:
          scopedFindingRuleResponse.scopedFindingRule[0].location_function,
      };
      setParameters(params);
      const typeFilters = {
        ...(machineType?{machine:machineType}:{}),
        ...(params.hmi?{hmi:params.hmi}:{}),
        ...(params.node ? { node:{number:scopedFindingRuleResponse.scopedFindingRule[0].plc_function_node_number,name:params.node} } : {}),
        ...(params.function ? { func: {number:scopedFindingRuleResponse.scopedFindingRule[0].plc_function_number,name:params.function} } : {}),
      };
      dispatch(setTypeFilters(typeFilters));
    }
  }, [scopedFindingRuleResponse.scopedFindingRule]);

  useEffect(() => {
    if (isdeleteSuccess) {
      history.push(`/rules/select_finding_rule/select_scope?machine_type=${machine_type}&hmi_type=${hmi_type}&findingRuleId=${findingRuleId}`);
    }
  }, [isdeleteSuccess]);

  useEffect(() => {
    async function fetchData(){
      await dispatch(
        fetchNode({ machine_type: machine_type, hmi_type: hmi_type })
      );
    }
    if (hmi_type) {
      fetchData()
    }
  }, [hmi_type]);

  useEffect(() => {
    async function fetchData(){
      const node = scopedFindingRuleResponse.node.find(
        (n) => n.name === parameters.node
      );
      if(node && node.number){
        await dispatch(
          fetchFunction({
            machine_type: machine_type,
            hmi_type: hmi_type,
            node_number: node.number,
          })
        );
      }
    }
    if (parameters.node && scopedFindingRuleResponse.node.length>0) { 
      fetchData()
    }
  }, [parameters.node, scopedFindingRuleResponse.node]);

  const updateNote = () => {
    if (scopedFinding.note_text !== note.trim()) {
      const body = {
        finding_rule_id: scopedFinding.finding_rule_id,
        note_text: note,
        operation_eq:
          scopedFinding.operation !== "None" ? scopedFinding.operation : "",
        scope: scope,
      };
      dispatch(updateScopedFindingRule(body,machine_type,hmi_type));
      debounce(() => {
        dispatch(
          fetchScopedFindingRule({
            finding_rule_id: findingRuleId,
            machine_type:machine_type,
            hmi_type:hmi_type,
            scope: scope,
          })
        );
      });
    }
    setTextEdit(false);
  };

  const handleNodeChange = (e, value, reason) => {
    let param = {};
    if (reason == "clear") {
      const body = {
        finding_rule_id: scopedFinding.finding_rule_id,
        scope: scope,
        node_number: "none",
      };
      dispatch(updateScopedFindingRule(body,machine_type, hmi_type));
      param = { ...parameters, node: "", function: "" };
    } else {
      param = { ...parameters, node: value.name, function: "" };
    }
    setParameters(param);
  };

  const handleFunctionChange = (e, value, reason) => {
    let param = {};
    let funValue = value ? value.number : "";
    if (reason === "clear") {
      funValue = "none";
      param = { ...parameters, function: "" };
    } else {
      param = { ...parameters, function: value.name };
    }
    setParameters(param);
    const body = {
      finding_rule_id: scopedFinding.finding_rule_id,
      scope: scope,
      hmi_type: parameters.hmi,
      node_number: scopedFindingRuleResponse.node.find(
        (n) => n.name === parameters.node
      ).number,
      function_number: funValue,
    };
    dispatch(updateScopedFindingRule(body,machine_type, hmi_type));
    debounce(() => {
      dispatch(
        fetchScopedFindingRule({
          finding_rule_id: findingRuleId,
          machine_type: machine_type,
          hmi_type:hmi_type,
          scope: scope,
        })
      );
    });
  };

  const updatePriority = () => {
    if (priority >= 0 && priority <= 100) {
      const body = {
        finding_rule_id: scopedFinding.finding_rule_id,
        scope: scope,
        priority: priority,
      };
      dispatch(updateScopedFindingRule(body,machine_type,hmi_type));
      setPrioEdited(false);
    }
  };

  const handleDeleteScope = () => {
    dispatch(deleteScopedFinding(findingRuleId, scope,machine_type,hmi_type));
  };

  return (
    <Grid container spacing={3}>
      <BreadcrumbDispatch />
      <Grid item md={9}>
        {scopedFindingRuleResponse.error && (
          <ErrorHandler message={scopedFindingRuleResponse.error} />
        )}
        {error && <ErrorHandler message={error} />}

        <Paper className={classes.containerPaper}>
          <Grid container>
            <Grid item>
              <Typography className="text-secondary" variant="h5">
                Scoped Finding Rule Configuration
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip title="question">
                <HelpOutlineIcon className={classes.icon} />
              </Tooltip>
            </Grid>
          </Grid>
          {(scopedFindingRuleResponse.loading || scopedFindingRuleResponse.componentLoading) && <SkeletonPaper row={2} />}

          {!scopedFindingRuleResponse.loading && !scopedFindingRuleResponse.componentLoading && (
            <Paper
              id="sfrcDetails"
              className={classes.detailsPaper}
              elevation={0}
            >
              <Grid container spacing={2} direction="column">
                {findingRuleResponse.selectFindingRule &&
                  findingRuleResponse.selectFindingRule
                    .map((finding) => (
                      <Grid key={finding.id} item container spacing={2}>
                        <Grid item md={3}>
                          <Typography variant="subtitle2">
                            Finding Rule Name
                          </Typography>
                        </Grid>
                        <Grid item md={1}>
                          -
                        </Grid>
                        <Grid item md={8}>
                          <Typography  className="black-text">
                            {finding.name}
                          </Typography>
                        </Grid>
                        <Grid item container spacing={2}>
                            <Grid item md={3}>
                              <Typography variant="subtitle1">Description</Typography>
                          </Grid>
                          <Grid item md={1}>
                            -
                          </Grid>
                            <Grid item md={8}>
                              <Typography  className="black-text">
                                {finding.description}
                              </Typography>
                            </Grid>
                          </Grid>
                      </Grid>
                    ))}                 
                <Grid item container spacing={2}>
                  <Grid item md={3}>
                    <Typography variant="subtitle1">Scope</Typography>
                  </Grid>
                  <Grid item md={1}>
                    -
                  </Grid>
                  <Grid item md={8}>
                    <Typography  className="black-text">
                      {scope}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item container spacing={2}>
                  <Grid item md={3}>
                    <Typography variant="subtitle1">Note Text</Typography>
                  </Grid>
                  <Grid item md={1}>
                    -
                  </Grid>
                  <Grid item md={8}>
                    {!textEdit ? (
                      <>
                        <Typography
                          
                          style={{ float: "left",wordBreak: 'break-all',overflowWrap: 'break-word'}}
                          className="black-text"
                        >
                          {scopedFinding.note_text
                            ? scopedFinding.note_text
                            : ""}
                        </Typography>
                        <Button
                          style={{ marginLeft: 0 }}
                          onClick={() => setTextEdit(true)}
                          className={classes.textEditButton}
                        >
                          Edit
                        </Button>
                      </>
                    ) : (
                      <>
                        <TextField
                          id="filled-scopedFinding"
                          value={note}
                          onChange={(e) => setNote(e.target.value)}
                          style={{ float: "left",width:'80%'}}
                          // InputProps={{ disableUnderline: true }}
                        ></TextField>
                        <Button
                          style={{ marginLeft: 0 }}
                          onClick={(e) => updateNote(e.target.value)}
                          className={classes.textEditButton}
                        >
                          Save
                        </Button>
                      </>
                    )}
                  </Grid>
                </Grid>
                <Grid item container spacing={2}>
                  <Grid item md={3}>
                    <Typography variant="subtitle1">Location</Typography>
                  </Grid>
                  <Grid item md={1}>
                    <div>-</div>
                  </Grid>
                  <Grid item md={4}>
                    <Autocomplete
                      id="modul"
                      disabled={
                        !scopedFindingRuleResponse.node.length>0
                      }
                      style={{background:'#fff'}}
                      onChange={handleNodeChange}
                      value={
                        scopedFindingRuleResponse.node.length>0 &&
                        scopedFindingRuleResponse.node.find(
                          (node) => parameters.node === node.name
                        )
                      }
                      options={scopedFindingRuleResponse.node}
                      getOptionLabel={(option) => option.name ? option.name : ''}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Modul"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <Autocomplete
                      id="function_group"
                      disabled={
                        !parameters.node || !scopedFindingRuleResponse.function.length>0
                      }
                      style={{background:'#fff'}}
                      onChange={handleFunctionChange}
                      value={
                        scopedFindingRuleResponse.function.length>0 &&
                        scopedFindingRuleResponse.function.find(
                          (fn) => fn.name === parameters.function
                        )
                      }
                      options={scopedFindingRuleResponse.function}
                      getOptionLabel={(option) => {
                        if (!option.name) return "";
                        return option.name;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Function Group"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Grid item container spacing={2}>
                  <Grid item md={3}>
                    <Typography variant="subtitle1">Priority</Typography>
                  </Grid>
                  <Grid item md={1}>
                    <div>-</div>
                  </Grid>
                  <Grid item md={4}>
                    {!prioEdited ? (
                      <>
                        <Typography
                          
                          style={{ float: "left" }}
                          className="black-text"
                        >
                          {priority}
                        </Typography>
                        <Button
                          style={{ marginLeft: 0 }}
                          onClick={() => setPrioEdited(true)}
                          className={classes.textEditButton}
                        >
                          Edit
                        </Button>
                      </>
                    ) : (
                      <>
                        <TextField
                          id="filled-scopedFinding"
                          value={priority}
                          type="number"
                          error={priority > 100 || priority < 0}
                          InputProps={{ inputProps: { min: 0, max: 100 } }}
                          onChange={(e) => {
                            setPriority(e.target.value);
                          }}
                          style={{ float: "left" }}
                          helperText="Priority must be within 0 to 100"
                        />
                        <Button
                          style={{ marginLeft: 0 }}
                          onClick={updatePriority}
                          className={classes.textEditButton}
                        >
                          Save
                        </Button>
                      </>
                    )}
                  </Grid>
                  <Grid item md={4} style={{textAlign: "right"}}>
                    <Button
                      variant="outlined"
                      className="btn-white"
                      onClick={() => setDeleteDialogOpen(true)}
                    >
                      DELETE SCOPED FINDING RULE
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          )}
          <DeleteConfirmDialog
            open={deleteDialogOpen}
            handleDelete={handleDeleteScope}
            message={" Do you want to delete this Scoped Finding Rule?"}
            handleConfirm={() => setDeleteDialogOpen(false)}
          />
          { !scopedFindingRuleResponse.componentLoading && <AnomalyConfiguration
            operationProp={scopedFinding.operation}
            findingRuleId={findingRuleId}
            scope={scope}
            noteText={note}
          />}
          {!scopedFindingRuleResponse.componentLoading && <Recommendation scope={scope} />}
        </Paper>
      </Grid>
      <Grid item md={3} className="helpBlock">
        <Paper className={classes.containerPaper}>
          <Box component="div" className="helpBlockTitle">
            Help
          </Box>
          <p className="helpTest">
            Finding Rules are abstract occurrence that affect a machine.
          </p>
          <p className="helpTest">
            Select a Finding rule from the table to proceed to configure its
            scope and Scoped Finding rules within the scope.
          </p>
          <p className="helpTest">
            Anomaly configuration and Recommendations ranking is available under
            Scoped Finding Configuration.
          </p>
          <hr style={{ color: "#E5E5E5" }} />

          <p className="helpQuestion">
            How to search and select a Finding Rule Step
            {/* 1: Use the search bar to type the keywords based on Name of the Finding Rule you are looking for. Step 2: Select the correct Finding Rule from the table. Step 3: Press Confirm, to confirm the selection. */}
          </p>
          <p className="helpQuestion">
            How to create a new Finding Rule
            {/* Step 1: Click on Create on the upper right corner of screen. Step 2: Enter name and description for the Finding Rule Step 3: Press Continue, to continue to define the Finding Rule. Note: A finding rule definition is incomplete without, at least one scoped finding definition within its scope. */}
          </p>
          <Box component="div" className="helpBlockImg">
            <img
              src={HelpBlockImg}
              alt="HelpBlockImg"
              className="img-fluid"
              style={{ display: "block", margin: "auto", width: "100%" }}
            />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
});

export default function ScopedFindingRuleConfiguration() {
  useEffect(()=>{
    if(!history.location.search)
    {
      history.push('/rules');
      return;
    }
  },[])

  return (
    <Suspense fallback="">
      <ScopedFindingRuleConfigurationComponent />
    </Suspense>
  );
}
